import { registerPlugin } from '@capacitor/core';

export interface PasswordCredential {
  username: string;
  password: string;
}

export interface PasswordCredentialOptions {
  username: string;
  password: string;
}

export interface GetPasswordOptions {
  username?: string;
}

export interface NativeCredentialManagerPlugin {
  getPassword(options?: GetPasswordOptions): Promise<PasswordCredential>;
  savePassword(options: PasswordCredentialOptions): Promise<void>;
}

let pendingPasswordCredential: PasswordCredential | null = null;

export function cachePasswordCredential(credential: PasswordCredential): void {
  pendingPasswordCredential = credential;
}

export function clearPasswordCredential(): void {
  pendingPasswordCredential = null;
}

export function takePasswordCredential(username: string): PasswordCredential | null {
  const credential = pendingPasswordCredential;

  if (
    !credential ||
    credential.username.trim().toLowerCase() !== username.trim().toLowerCase()
  ) {
    return null;
  }

  pendingPasswordCredential = null;
  return credential;
}

export const NativeCredentialManager =
  registerPlugin<NativeCredentialManagerPlugin>('NativeCredentialManager');
